var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-count"},[(!_vm.printMode)?_c('el-input',{attrs:{"placeholder":"","readonly":""},model:{value:(_vm.value2),callback:function ($$v) {_vm.value2=$$v},expression:"value2"}}):_c('span',{staticClass:"showText"},[_vm._v(_vm._s(_vm.value2))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }